import { RegisterForm } from '../../components/auth/register-form';

export const Register = () => {
	return <RegisterForm />
}
